<template>
  <div class="location" id="location" v-if="hideCity || addressModalFlag || addressPickerFlag">
    <div class="location-wrap" @click="showAddress" v-if="hideCity">
      <div class="location-wrap-tip">{{ entityFlag ? TLang('配送至', 'address') : TLang('城市', 'result') }}：</div>
      <div v-if="entityFlag" class="location-wrap-siji">{{ (addressInfo.cityName || addressInfo.name) + (addressInfo.districtName || addressInfo.regionName) + addressInfo.streetName }}</div>
      <div v-else class="location-wrap-city">{{ this.getDFLANG() ? addressInfo.cityNameValue : addressInfo.cityName || addressInfo.name }}</div>
      <div class="location-wrap-arrow" :class="addressFlag ? 'location-wrap-up' : 'location-wrap-down'"></div>
    </div>
    <CityList
      :isShow="cityModalFlag"
      :Hcity="cityInfo.hotCities"
      :Cdata="cityInfo.cityList"
      :HisData="cityInfo.historyCities"
      :isGetIpAddress="isGetIpAddress"
      :positionAddress="positionAddress"
      @closePops="closePops"
      @handleReload="pageReload"
    />
    <div v-if="addressModalFlag">
      <AddressModal
        :isShow="addressModalFlag"
        :isGetIpAddress="isGetIpAddress"
        :userAddressList="userAddressList"
        :positionAddress="positionAddress"
        :Cdata="cityInfo.cityList"
        @closePops="closePops"
        @handleReload="pageReload"
        @changePicker="changePicker"
        @handleLocation="handleLocation"
      />
    </div>
    <div v-if="addressPickerFlag">
      <AddressPicker :isShow="addressPickerFlag" :Cdata="cityInfo.cityList" :provinceList="provinceList" @closePops="closePops" @backPops="backPops" @handleReload="pageReload" />
    </div>
  </div>
</template>

<script>
import { getCookie, getQueryString, unionFlag, getCookieAddressInfo, getChannelRouter, checkUnifyShop , hideUserCity} from '../utils';
import { raf } from '../utils/raf.js';
import { publicFunc } from '../utils/func';
import CityList from './CityList.vue';
import AddressModal from './AddressModal';
import AddressPicker from './AddressPicker.vue';
import { initAddressDF } from 'dflocationsdk';
export default {
  name: 'Location',
  props: {
    entityFlag: {
      type: Boolean,
      default: false,
    },
    isGetIpAddress: {
      type: Boolean,
      default: false,
    },
    cityInfo: Object,
    positionAddress: Object,
    userAddressList: Array,
    provinceList: Array,
    singleChannel: String,
    path: String,
  },
  components: {
    CityList,
    AddressModal,
    AddressPicker,
  },
  data() {
    return {
      addressFlag: false, // 按钮状态切换
      addressInfo: getCookieAddressInfo() || JSON.parse(getCookie('address')) || {}, // 缓存地址信息
      cityModalFlag: false, // 城市选择弹窗
      addressModalFlag: false, // 地址选择弹窗
      addressPickerFlag: false, // 四级地址选择弹窗
    };
  },
  created() {
    initAddressDF(false, null, false, '', true).then((resAddress) => {
      this.addressInfo = resAddress;
    });
    console.log('看看定位地址信息', this.isGetIpAddress);
  },
  methods: {
    getDFLANG() {
      const union = unionFlag() || sessionStorage.getItem('dffl_union');
      return publicFunc.getCookie('df_lang') == 'en-US' && (union || checkUnifyShop());
    },
    // 显示地址选择
    showAddress() {
      if (this.entityFlag) {
        // 四级地址选择
        this.addressFlag = true;
        this.addressModalFlag = true;
      } else {
        // 城市选择
        this.addressFlag = true;
        this.cityModalFlag = true;
      }
    },
    // 切换地址重新请求数据
    pageReload() {
      let url = window.location.href;
      let origin = window.location.origin;
      let newURL = url;
      if (getQueryString('index')) {
        newURL = publicFunc.changeURLArg(newURL, 'index', 0);
      }
      if (getQueryString('productTypes')) {
        newURL = publicFunc.changeURLArg(newURL, 'productTypes', '');
      }
      if (getQueryString('city')) {
        newURL = publicFunc.changeURLArg(newURL, 'city', '');
      }
      const query = newURL.split('?')[1];
      setTimeout(() => {
        if (this.singleChannel) {
          const pathName = getChannelRouter(this.singleChannel);
          window.location.href = origin + `/ms/${pathName}?` + query;
        } else {
          window.location.href = origin + `${location.pathname
            }?` + query
          // window.location.href = origin + '/ms/home?' + query;
        }
      }, 10);
    },
    // 关闭城市选择弹窗
    closePops() {
      this.addressFlag = false;
      this.cityModalFlag = false;
      this.addressModalFlag = false;
      this.addressPickerFlag = false;
    },
    backPops() {
      this.addressModalFlag = true;
      this.addressPickerFlag = false;
    },
    // 切换选择其他地址
    changePicker() {
      this.addressModalFlag = false;
      this.addressPickerFlag = true;
    },
    // 通知父组件更新定位信息
    handleLocation(data) {
      this.$emit('handlePosition', data);
    },
  },
  computed: {
    hideCity() {
      return !hideUserCity(this.path);
    },
  },
  // watch: {
  //   cityInfo(newValue) {
  //     console.log('啥地方顺丰到付水电费水电费三大放松放松懂法守法水电费水电费水电费水电费三大')
  //   },
  // },
};
</script>

<style lang="less" scoped>
@375: 320/375;
.location {
  height: 40px * @375;
  background: #fff;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px * @375;
  font-size: 14px * @375;

  font-weight: 400;
  color: #999999;
  line-height: 40px * @375;
  &-wrap {
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    &-tip {
      flex-shrink: 0;
    }
    &-siji {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &-city {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &-arrow {
      flex-shrink: 0;
      margin-left: 5px * @375;
      width: 12px;
      height: 12px;
    }
    &-up {
      background: url('../assets/imgs/icon_address_up.png') center center no-repeat;
      background-size: 100% auto;
    }
    &-down {
      background: url('../assets/imgs/icon_address_down.png') center center no-repeat;
      background-size: 100% auto;
    }
  }
}
</style>
